import { render, staticRenderFns } from "./Socio-edit.vue?vue&type=template&id=36dea152"
import script from "./Socio-edit.vue?vue&type=script&lang=js"
export * from "./Socio-edit.vue?vue&type=script&lang=js"
import style0 from "./Socio-edit.vue?vue&type=style&index=0&id=36dea152&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports